import React from 'react';
import evemts from 'utils/evemts';
import http from 'utils/http';
import { setDeleteAction } from 'store/actions/deleteAction';
import { connect } from 'react-redux';
import EmailTemplate from './EmailTemplate';

class EmailTemplateContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mails: [],
      mailFields: {},
      mailFieldsErrors: {},
      footer: '',
      cc: '',
      bcc: '',
      footerErrors: false,
      ccErrors: false,
      bccErrors: false,
      modal: false,
      bounce: '',
      bounceErrors: {},
    };
    this.eventSource = null;
  }

  componentDidMount() {
    this.fetchMailTemp();
    this.fetchMailFooter();
    this.fetchMailCC();
    this.fetchMailBCC();
    this.fetchBounce();
    this.eventSource = evemts('admin', 'import');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (msg.data && msg.action && msg.action == 'mail_temp') {
        this.setState({ mails: msg.data?.value || [] });
      }

      if (msg.data && msg.action && msg.action == 'mail_footer') {
        this.setState({ footer: msg.data?.value?.footer || '' });
      }

      if (msg.data && msg.action && msg.action == 'mail_cc') {
        this.setState({ cc: msg.data?.value?.cc || '' });
      }

      if (msg.data && msg.action && msg.action == 'mail_bcc') {
        this.setState({ bcc: msg.data?.value?.bcc || '' });
      }
      
      if (msg.data && msg.action && msg.action == 'mail_bounce') {
        this.setState({ bounceList: msg.data?.value?.bounce || '' });
      }
    };
  }

  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close();
    }
  }

  fetchMailTemp = () => {
    http.get('/settings?key=mail_temp').then(({ data }) => {
      if (data.data) {
        let mail = data.data?.find((item) => item.key === 'mail_temp');
        if (mail) {
          this.setState({ mails: mail?.value || [] });
        }
      }
    }
    );
  };

  fetchMailFooter = () => {
    http.get('/settings?key=mail_footer').then(({ data }) => {
      if (data.data) {
        let footer = data.data?.find((item) => item.key === 'mail_footer');
        if (footer) {
          this.setState({ footer: footer?.value?.footer || '' });
        }
      }
    });
  };

  fetchMailCC = () => {
    http.get('/settings?key=mail_cc').then(({ data }) => {
      if (data.data) {
        let cc = data.data?.find((item) => item.key === 'mail_cc');
        if (cc) {
          this.setState({ cc: cc?.value?.cc || '' });
        }
      }
    });
  };

  fetchMailBCC = () => {
    http.get('/settings?key=mail_bcc').then(({ data }) => {
      if (data.data) {
        let bcc = data.data?.find((item) => item.key === 'mail_bcc');
        if (bcc) {
          this.setState({ bcc: bcc?.value?.bcc || '' });
        }
      }
    });
  };

  handleOpen = (modal, anchorEl = null, modalData = false) => {
    this.setState({
      modal,
      anchorEl,
      modalData
    });
  };

  handleClose = () => {
    this.setState({
      modal: false,
      anchorEl: null,
      modalData: false,
    });
  };

  onChangeMail = (e) => {
    let value = e.target.value;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    this.setState({
      mailFields: {
        ...this.state.mailFields,
        [e.target.name]: value,
      },
    });
  };

  validateMailForm = () => {
    let mailFieldsErrors = {};
    let isValid = true;
    if (!this.state.mailFields.type) {
      mailFieldsErrors.type = true;
      isValid = false;
    }
    if (this.state.mailFields.type == 'Text' || this.state.mailFields.type == 'Text SPL') {
      if (!this.state.mailFields.name) {
        mailFieldsErrors.name = true;
        isValid = false;
      }
      if (!this.state.mailFields.value) {
        mailFieldsErrors.value = true;
        isValid = false;
      }
    }
    if(this.state.mailFields.type == 'Text SPL' && !this.state.mailFields.condition_spl) {
      mailFieldsErrors.condition_spl = true;
      isValid = false;
    }
    this.setState({ mailFieldsErrors });
    return isValid;
  };

  swap = (direction, index) => {
    let data = {
      index: index,
      up: direction == 'up' ? true : false,
      down: direction == 'down' ? true : false,
    };
    http.put('/setting/mail_temp/swap', data);
  };

  onRowMailClick = (row) => {
    this.setState({
      mailFields: {
        ...row,
        old_name: row.name 
      },
      mailFieldsErrors: {}
    });
  };

  editMail = (e) => {
    e.preventDefault();
    if (this.validateMailForm()) {
      let data = {
        type: this.state.mailFields.type,
        name: this.state.mailFields.name || null,
        old_name: this.state.mailFields.old_name || null,
        value: this.state.mailFields.value || null,
        condition_spl: this.state.mailFields.condition_spl? this.state.mailFields.condition_spl?.toUpperCase() : null,
      };
      http.put('setting/mail_temp', data).then(({ data }) => {
        if (data.status == 'success') {
          this.setState((prevState) => ({
            mailFields: {
              ...prevState.mailFields,
              type: '',
              name: '',
              value: '',
              condition_spl: '',
            }
          }));
        }
      }).catch(error => {
        console.error('Error fetching data:', error);
      });
    }
  };

  handleDeleteMail = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteMail(id),
    });
  };

  deleteMail = (id) => {
    http.delete('setting/mail_temp/' + id).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };

  onChangeFooter = (e) => {
    let value = e.target.value;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    this.setState({
      footer: value,
      footerErrors: false,
    });
  };

  onChangeCC= (e) => {
    let value = e.target.value;
    this.setState({
      cc: value,
      ccErrors: false,
    });
  };

  onChangeBCC= (e) => {
    let value = e.target.value;
    this.setState({
      bcc: value,
      bccErrors: false,
    });
  };

  saveMailFooter = (e) => {
    e.preventDefault();
    if (!this.state.footer) {
      this.setState({ footerErrors: true });
    } else {
      http.put('setting/mail_footer', { value: { footer: this.state.footer } });
    }
  };

  saveMailCC = (e) => {
    e.preventDefault();
    if (!this.state.cc) {
      this.setState({ ccErrors: true });
    } else {
      http.put('setting/mail_cc', { value: { cc: this.state.cc } });
    }
  };

  saveMailBCC = (e) => {
    e.preventDefault();
    if (!this.state.bcc) {
      this.setState({ bccErrors: true });
    } else {
      http.put('setting/mail_bcc', { value: { bcc: this.state.bcc } });
    }
  };

  fetchBounce =() => {
    http.get('/settings?key=mail_bounce').then(({ data }) => {
      if (data.data) {
        let bounce = data.data?.find((item) => item.key === 'mail_bounce');
        if (bounce) {
          this.setState({ 
            // bounce: bounce?.value?.bounce || '',
            bounceList: bounce?.value?.bounce || '', 
          });
        }
      }
    });
  };
    
  onChangeBounce= (e) => {
    let value = e.target.value;
    this.setState(() => ({
      bounce: value,
      bounceErrors: false,
    }));
  };
    
  validation = () => {
    let formValid = true;
    const error = {};
    if (
      this.state.bounce &&
          !this.state.bounce
            .split(',')
            .map(email => email.trim())
            .every(email => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email))
    ) {
      formValid = false;
      error.bounce = 'Enter valid email';
    }
    //DUPLICATE CHECK
    else if (this.state.bounce && this.state.bounceList) {
      const existingEmails = this.state.bounceList.split(',').map(email => email.trim());
      const newEmails = this.state.bounce.split(',').map(email => email.trim());
      const duplicateEmails = newEmails.filter(email => existingEmails.includes(email));
      if (duplicateEmails.length > 0) {
        formValid = false;
        error.bounce = `Duplicate emails: ${duplicateEmails.join(', ')}`;
      }
    }
    else formValid = true;
    this.setState({ bounceErrors: error });
    
    return formValid;
  };
    
  saveMailBounce = (e) => {
    if (e) {
      e.preventDefault();
    }
    let bounceList = this.state.bounceList  ? this.state.bounceList + ',' + this.state.bounce : this.state.bounce;
    if (this.validation()) {
      http.put('setting/mail_bounce', { value: { bounce: bounceList } }).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            // modal: false,
            bounceErrors: {},
            bounce: '',
          });
        }
      }); 
    }
  };

  onDeleteBounceEmail = (email) => {
    const bounceList = this.state.bounceList || '';
    const selectedEmail = bounceList.split(',').filter(e => e.trim() != email).join(',');
    this.setState({ bounceList: selectedEmail }, () => {
      this.saveMailBounce();
    });
  };

  render() {
    return (
      <>
        <EmailTemplate
          mails={this.state.mails}
          onChangeMail={this.onChangeMail}
          mailFields={this.state.mailFields}
          mailFieldsErrors={this.state.mailFieldsErrors}
          onRowMailClick={this.onRowMailClick}
          swap={this.swap}
          handleDeleteMail={this.handleDeleteMail} 
          editMail={this.editMail}
          footer={this.state.footer}
          footerErrors={this.state.footerErrors}
          onChangeFooter={this.onChangeFooter}
          saveMailFooter={this.saveMailFooter}
          cc={this.state.cc}
          ccErrors={this.state.ccErrors}
          onChangeCC={this.onChangeCC}
          saveMailCC={this.saveMailCC}
          bcc={this.state.bcc}
          bccErrors={this.state.bccErrors}
          onChangeBCC={this.onChangeBCC}
          saveMailBCC={this.saveMailBCC}
          // bounce email
          bounce={this.state.bounce}
          bounceErrors={this.state.bounceErrors}
          onChangeBounce={this.onChangeBounce}
          saveMailBounce={this.saveMailBounce}
          onDeleteBounceEmail={this.onDeleteBounceEmail}
          handleOpen={this.handleOpen}
          handleClose={this.handleClose}
          modal={this.state.modal}
          bounceList={this.state.bounceList}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(EmailTemplateContainer);